<template>
	<div id="app">
		<div class="page-loader" v-if="ui.window.loaded === false"></div>
		<div class="row h-100" v-if="ui.window.loaded === true && ui.window.error === true">
			<div class="col-sm-12 my-auto">
				<div class="alert alert-danger m-auto" style="max-width: 50%;" role="alert">
					<p>Υπήρξε τεχνικό πρόβλημα.</p>
					<p>Παρακαλώ προσπαθήστε αργότερα</p>
					<hr />
					<p>There was a technical problem.</p>
					<p>Please try again later</p>
				</div>
			</div>
		</div>
		<div v-else>
			<main-menu></main-menu>
			<div class="container pt-3">
				<div class="alert alert-success mb-3" v-bind:class="ui.alert.type" role="alert" v-if="ui.alert.text.trim() !== ''" v-html="ui.alert.text.trim()"></div>
				<router-view></router-view>
			</div>
		</div>
	</div>
</template>

<script>
import Mixin from "@/helpers/mixin";
import MainMenu from "@/components/MainMenu";

export default {
	name: "app",
	mixins: [Mixin],
	components: { MainMenu },
	created() {
		this.$store
			.dispatch("http_get_settings")
			.then(resp => {
				if (resp === true) {
					return this.$store.dispatch("http_get_translations");
				}
			})
			.then(resp => {
				if (resp === true) {
					this.$store.commit("app_loaded", { loaded: true, error: false });
				}
			})
			.catch(e => {
				console.log(e);
				this.$store.commit("app_loaded", { loaded: true, error: true });
			});
	}
};
</script>

<style>
button > * {
	pointer-events: none;
}
html,
body {
	height: 100%;
}
#app {
	font-family: "Avenir", Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
	height: 100%;
}
.modal-header {
	border-bottom: none;
}
.modal-footer {
	border-top: none;
}
.page-loader {
	position: fixed;
	width: 100%;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 9999;
}
@keyframes spin {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
}
.page-loader::after {
	content: "";
	display: block;
	position: absolute;
	left: 48%;
	top: 40%;
	width: 40px;
	height: 40px;
	border-style: solid;
	border-color: #2c3e50;
	border-top-color: transparent;
	border-width: 4px;
	border-radius: 50%;
	-webkit-animation: spin 0.8s linear infinite;
	animation: spin 0.8s linear infinite;
}
i {
	border: solid #000000;
	border-width: 0 3px 3px 0;
	display: inline-block;
	padding: 3px;
	margin: 0 1em 0 1em;
}
.right {
	transform: rotate(-45deg);
	-webkit-transform: rotate(-45deg);
}
.left {
	transform: rotate(135deg);
	-webkit-transform: rotate(135deg);
}
.up {
	transform: rotate(-135deg);
	-webkit-transform: rotate(-135deg);
}
.down {
	transform: rotate(45deg);
	-webkit-transform: rotate(45deg);
}
.cursor-pointer:hover {
	cursor: pointer;
}
::-webkit-scrollbar {
	width: 0.6em;
	height: 0.6em;
	margin-bottom: 0.6em;
}
::-webkit-scrollbar-track {
	box-shadow: inset 0 0 5px #f5f5f5;
}
::-webkit-scrollbar-thumb {
	background: #2c3e50;
}
body.dark {
	background-color: #111111 !important;
	color: #ffffff;
}
body.dark nav,
body.dark nav .navbar-container {
	background-color: #2d2d2d !important;
	color: #ffffff;
}
body.dark .main-menu.menu-dark,
body.dark .main-menu.menu-bg-default,
body.dark .main-menu.menu-dark .main-menu-header .menu-search,
body.dark .main-menu.menu-dark .main-menu-header .menu-search:focus,
body.dark .main-menu.menu-dark .navigation,
body.dark .main-menu.menu-dark .navigation > li.open > a,
body.dark .main-menu.menu-dark .navigation > li .active,
body.dark .main-menu.menu-dark .navigation > li .active .hover > a,
body.dark .main-menu.menu-dark .navigation > li > ul,
body.dark .main-menu.menu-dark ul.menu-popout,
body.dark .main-menu.menu-dark ul.menu-popout .open > ul .open,
body.dark .main-menu.menu-dark ul.menu-popout .open > ul .open > ul {
	box-shadow: none !important;
	-webkit-box-shadow: none !important;
	background: #2d2d2d !important;
	background-color: #2d2d2d;
	color: #ffffff;
	border-color: #1f1f1f;
}
body.dark table,
body.dark table tr,
body.dark table td,
body.dark table th {
	border-color: #1f1f1f !important;
	color: #EEEEEE !important;
}
body.dark h1,
body.dark h2,
body.dark h3,
body.dark h4,
body.dark h5,
body.dark h6,
body.dark .h1,
body.dark .h2,
body.dark .h3,
body.dark .h4,
body.dark .h5,
body.dark .h6,
body.dark .breadcrumb-item.active {
	color: #ffffff;
}
body.dark .content-header-title {
	color: #ffffff !important;
}
body.dark a:not(.btn) {
	color: #429ce3;
}
body.dark .dropdown-menu a {
	color: #ffffff;
}
body.dark .progress {
	background-color: #3d3d3d;
}
body.dark input,
body.dark select,
body.dark select option,
body.dark .form-control,
body.dark input.form-control,
body.dark textarea {
	border-color: #1f1f1f;
	background-color: #3d3d3d;
	color: #ffffff;
}
body.dark .form-label-group input:not(:placeholder-shown) ~ label {
	color: #ffffff;
}
body.dark form label {
	color: #ffffff;
}
body.dark input:focus,
body.dark select:focus,
body.dark select option:focus,
body.dark .form-control:focus,
body.dark input.form-control:focus,
body.dark textarea:focus {
	border-color: #1f1f1f;
	background-color: #3d3d3d;
	color: #429ce3;
}
body.dark a:hover {
	color: #429ce3;
}
body.dark input:disabled,
body.dark select:disabled,
body.dark select option:disabled,
body.dark .form-control:disabled,
body.dark input.form-control:disabled,
body.dark span.input-group-text,
body.dark textarea:disabled {
	border-color: #1f1f1f;
	background-color: #1d1d1d;
	color: #ffffff;
}
body.dark .dropdown-menu,
body.dark div.modal-content,
body.dark div.card,
body.dark div.card-body,
body.dark div.card-header,
body.dark div.card-footer {
	background-color: #2d2d2d;
	color: #ffffff;
	border-color: #1f1f1f;
}
body.dark .modal-header,
body.dark .modal-footer,
body.dark .dropdown-menu,
body.dark .dropdown-menu-header,
body.dark .dropdown-divider,
body.dark .header-navbar .navbar-container .dropdown-menu-media .media-list .media {
	border-color: #1f1f1f !important;
}
body.dark .table-hover tbody tr:hover,
body.dark .dropdown-item:hover,
body.dark .dropdown-item:focus {
	background-color: #3d3d3d;
	color: #ffffff;
}
body.dark i.black {
	color: #ffffff !important;
}
body.dark .nav-tabs .nav-link.active,
body.dark .nav-tabs .nav-item.show .nav-link {
	color: #ffffff;
	background-color: #2d2d2d;
	border-bottom: 0;
}
body.dark .nav-tabs {
	border-bottom: 1px solid #3d3d3d;
	overflow-x: auto;
	overflow-y: hidden;
	flex-wrap: nowrap;
	white-space: nowrap;
}
body.dark .nav-tabs .nav-link {
	border-color: #3d3d3d #3d3d3d #3d3d3d;
}
body.dark .nav.nav-tabs .nav-item:hover {
	color: #fff;
}
@media (max-width: 767.98px) {
	body.dark .navbar-light .navbar-header .navbar-nav .nav-link,
	body.dark .navbar-semi-light .navbar-header .navbar-nav .nav-link {
		color: #6b6f82;
	}
}
body.dark .was-validated .form-control:invalid,
body.dark .form-control.is-invalid,
body.dark .was-validated .custom-select:invalid,
body.dark .custom-select.is-invalid {
	border-color: #ff4961 !important;
}
body.dark .list-group-item {
	background-color: #3d3d3d;
	color: #ffffff;
}

.card-header{
	font-weight: bold;
	font-size: 18px;
}
</style>
